import { Component } from "@angular/core";

import { OnInit } from "@angular/core";
import {WmsWorkspaceManagerService} from "@wms/workspace";
import {ProjectService} from "@wms/services";
import { sendToAIStudio } from '@wms/core'
@Component({
  selector: 'app-proxy-studio-ai-workspace',
  template: ''
})
export class ProxyStudioAiWorkspaceComponent implements OnInit  {
  constructor(private wsManager: WmsWorkspaceManagerService, private projectService: ProjectService) {
    this.wsManager.setActiveWSCategory('AISTUDIO');
    this.wsManager.setIsAIStudioLoaded(true);
  }
  ngOnInit(): void {
    if(this.wsManager.isMessageServiceReady) {
      let metadata= {workspace: this.wsManager.activeWS};
      //fix this later. It should be fixed in the style workspace - style.component
      metadata.workspace = this.wsManager.activeWS.details ? this.wsManager.activeWS : this.wsManager.activeWS.meta;
      if(this.wsManager.activeWS.details?.id === "JAVASERVICE" || this.wsManager.activeWS.details?.id === "APISERVICE") {
        //@ts-ignore
        metadata.serviceClasses = this.wsManager.serviceClassesMetaData;
      }
      sendToAIStudio(metadata);
    }
  }

}
